var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("App")]),_vm._v(" "),_c('label',{attrs:{"for":"manifestUrl"}},[_vm._v("manifestUrl")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"manifestUrl"},model:{value:(_vm.config.manifestUrl),callback:function ($$v) {_vm.$set(_vm.config, "manifestUrl", $$v)},expression:"config.manifestUrl"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f4071ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigureComponents/App.vue
// module id = null
// module chunks = 